module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/admin/icons/member-d537bf43f8e54669e2841ac7c2932a9c.svg&quot;;"